import {
    JustpayConfigurationEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-configuration-endpoint-service"

export class JustpayConfigurationService {
    constructor (store) {
        this.justpayEndpointCommonService = new JustpayConfigurationEndpointService(store)
    }

    async copyConf (configurationId) {
        return this.justpayEndpointCommonService.copyConf(configurationId)
    }
}
